// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ReceiptXIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27 5H5a2 2 0 0 0-2 2v19a1 1 0 0 0 1.447.894L8 25.118l3.553 1.776a.999.999 0 0 0 .894 0L16 25.118l3.552 1.776a.999.999 0 0 0 .896 0L24 25.118l3.552 1.776A1 1 0 0 0 29 26V7a2 2 0 0 0-2-2Zm0 19.383-2.552-1.278a1 1 0 0 0-.896 0L20 24.882l-3.552-1.777a1 1 0 0 0-.896 0L12 24.882l-3.553-1.777a1 1 0 0 0-.894 0L5 24.382V7h22v17.383Zm-14.707-7.09L14.585 15l-2.293-2.293a1 1 0 1 1 1.415-1.415L16 13.587l2.293-2.293a1 1 0 0 1 1.415 1.415L17.413 15l2.293 2.293a1 1 0 0 1-1.415 1.415L16 16.413l-2.293 2.293a1 1 0 0 1-1.415-1.415Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
